import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { BusinessPartnersElement } from '@/features/w/[identifier]/setting/business_partners/{components}/BusinessPartnersElement';
import { Link } from 'react-router-dom';

export const WorkspaceBusinessPartners = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('取引先設定'), []);
  useEffect(() => setBreadcrumbs([]), []);

  const { _w_, me } = useCurrentWorkspace();

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'business_partner'} />

        <div className="row">
          <div className="col-12 mx-auto">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">取引先一覧</h5>
                </div>
                <div className="col-md-4 d-flex justify-content-end">
                  {me!.admin && (
                    <Link
                      to={`/w/${_w_!.identifier}/setting/business_partners/new`}
                      className="btn bg-gradient-primary btn-icon"
                    >
                      <i className="fas fa-plus"></i>新規取引先登録
                    </Link>
                  )}
                </div>
              </div>

              <BusinessPartnersElement />
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
